



































import { Component, Vue, Prop } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";
import { ICustomAuthConfigDTO } from "../../Generated/ParticaAPI";

@Component(
	{
		name: "CustomAuthConfig",
		components: { ButtonList }
	})
export default class CustomAuthConfig extends ParticaBaseForm<ICustomAuthConfigDTO> {

	private secretconfig =
		{
			props: {
				name: "secret",
				placeholder: "Enter secret",
				label: "Shared Secret",
			} as FormFieldProps,
			rules: { required: true, max: 500, min: 0, } as FormFieldRules
		} as IFormField;

	private jWTExpirySecondsconfig =
		{
			props: {
				name: "JWT Expiry Seconds",
				placeholder: "Enter number of seconds a JWT is valid for.",
				label: "JWT Expiry Seconds",
			} as FormFieldProps,
			rules: { required: true, numeric: true, min_value: 600 } as FormFieldRules
		} as IFormField;

	private maxStaleRefreshconfig =
		{
			props: {
				name: "Max Stale Refresh",
				placeholder: "Enter number of seconds a JWT can be refreshed after it expires",
				label: "JWT Maximum allowed stale token refresh",
			} as FormFieldProps,
			rules: { required: true, numeric: true, min_value: 600 } as FormFieldRules
		} as IFormField;

	private getHours(val: number): string {
		return `${(val / 60 / 60).toFixed(2)} hours`;
	}

}
